import styled from "styled-components";
import {IndicatorIconDefaultBox} from "./indicator-icon.default.box";

export const IndicatorIconSIBox = styled(IndicatorIconDefaultBox)`
    position: relative;
`;
